import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import SharedLifestyleSection from '@/components/shared/SharedLifestyleSection';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface EditableLifestyleSectionProps {
  formData: any;
  updateLocalData: (field: string, value: any) => void;
  syncWithAuthContext: (updatedFields: Record<string, any>) => Promise<void>;
  userId: string;
}

const EditableLifestyleSection: React.FC<EditableLifestyleSectionProps> = ({
  formData,
  updateLocalData,
  syncWithAuthContext,
  userId
}) => {
  const [isSaving, setIsSaving] = useState<string | null>(null);

  const lifestyleData = {
    smoker: formData.smoker,
    drinker: formData.drinker,
    piercings: formData.piercings,
    tattoos: formData.tattoos,
    children: formData.children
  };

  const handleUpdateData = async (field: string, value: string) => {
    // Update local state immediately
    updateLocalData(field, value);
    
    // Auto-save to database
    if (!userId) return;
    
    setIsSaving(field);
    try {
      const { error } = await supabase
        .from('profiles')
        .update({ [field]: value })
        .eq('id', userId);

      if (error) throw error;

      await syncWithAuthContext({ [field]: value });
      toast.success('Salvo', { duration: 1500 });
    } catch (error) {
      console.error('Error updating lifestyle:', error);
      toast.error('Erro ao salvar');
    } finally {
      setIsSaving(null);
    }
  };

  return (
    <Card className="bg-white/5 border-white/10">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center">
              <span className="text-lg">🏃</span>
            </div>
            <h3 className="text-white font-medium text-lg">Estilo de Vida</h3>
          </div>
          {isSaving && (
            <span className="text-xs text-white/40">Salvando...</span>
          )}
        </div>

        <SharedLifestyleSection
          data={lifestyleData}
          updateData={handleUpdateData}
          isOnboarding={false}
          isEditing={true}
        />
      </CardContent>
    </Card>
  );
};

export default EditableLifestyleSection;
